import { Component, OnInit, SkipSelf } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UploadService } from 'src/app/shared/service/upload.service';

@Component({
  selector: 'ik-failed-upload-dialog',
  templateUrl: './failed-upload-dialog.component.html',
  styleUrls: ['./failed-upload-dialog.component.scss'],
  //  providers: [UploadService],
})
export class FailedUploadDialogComponent {
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    @SkipSelf() public uploadService: UploadService
  ) {}
  downloadUploadIssues() {
    this.uploadService.downloadUploadIssues(
      (this.config.data as { issueId: number }).issueId,
      this.ref
    );
  }
}